/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { bool, func, object } from 'prop-types';
import { useQuery } from '@apollo/client';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import mbpLogger from '@module-logger/mbp';
import findContent from '../../../gql/queries/findContent';

const findContentOptions = {
    brand: 'global',
    contentType: 'subscriptions_global_copy',
};
const GET_TERM_OF_USE_CONTENT = findContent(findContentOptions);

const styles = (theme) => ({
    dialogContent: {
        fontSize: '.8em',
        textWrap: 'pretty',
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },
    popUpHeading: {
        textAlign: 'center',
        '& span': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
});

const SubscriptionTermOfUse = ({ open, setOpen, classes }) => {
    const { data, loading, error } = useQuery(GET_TERM_OF_USE_CONTENT);

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: 'Failed to fetch term of use content.',
        });
    }
    if (!data || loading) {
        return null;
    }
    const copy = data?.findContent?.content?.entries?.[0]?.subscription_terms;
    if (!copy) return null;
    const title = 'Subscription Program Terms and Conditions';
    return (
        <Dialog data-testid="term-and-condition-modal" open={open} onClose={() => setOpen(false)}>
            <DialogTitle className={classes.popUpHeading} id="cterm-and-condition-modal-title">
                <span>{title}</span>
                <IconButton className={classes.closeBtn} aria-label="Close" onClick={() => setOpen(false)}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography gutterBottom className={classes.dialogContent}>
                    <ReactMarkdown source={copy} escapeHtml={false} />
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

SubscriptionTermOfUse.propTypes = {
    open: bool.isRequired,
    setOpen: func.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(SubscriptionTermOfUse);
